import { atom } from "recoil";

export const playerRulesAddModalStore = atom({
	key: "playerRulesAddModalStore",
	default: {
		show: false,
		loaded: true,
		currentOption: {
			module: [
				{value: "wallet_deposits", label: "Deposit"},
				{value: "wallet_withdraws", label: "Withdrawal"},
				{value: "data_users", label: "User"},
				{value: "promo_wheel", label: "Wheel"},
				{value: "data_users_sessions", label: "Session"},
				{value: "log_balance", label: "Log"},
				{value: "data_codes", label: "Promocode"},
				{value: "players_log", label: "Log panel"},
				{value: "log_sessions", label: "Log game session"},
				{value: "log_users_actions", label: "Action log"}
			],
			automaticPool: [
			//	{ value: "rejected_withdrawal", label: "Rejected withdrawal" },
			//	{ value: "canceled_withdrawal", label: "Canceled withdrawal" },
				{ value: "user_ban", label: "User ban" },
				{ value: "user_zero_balance", label: "User balance zero" },
				{ value: "forbidden_deposit", label: "Forbidden deposit" },
				{ value: "none", label: "None" }
			],
			actionBan: [{ value: "forbidden", label: "Forbidden" }, { value: "date", label: "Date" }]
		},
	},
});
